import { isNumber } from 'lodash'
import { Fee, FeeType } from '../Types'

export const assembleFee = (type: FeeType, amount?: number): Fee | undefined =>
  isNumber(amount) ? { amount: amount!, type } : undefined
